export const FACILITY_FILTER_TYPE = 1;
export const STATUS_FILTER_TYPE = 2;

export const POTENTIAL_STATUS_FILTER_ID = 1;
export const NOT_SUBMITTED_STATUS_FILTER_ID = 2;
export const SUBMITTED_STATUS_FILTER_ID = 3;
export const IN_REVISION_STATUS_FILTER_ID = 4;
export const NOT_PAID_STATUS_FILTER_ID = 5;
export const PARTIALLY_PAID_STATUS_FILTER_ID = 6;
export const FULLY_PAID_STATUS_FILTER_ID = 7;

export const statuses = [
  {
    id: POTENTIAL_STATUS_FILTER_ID,
    name: 'Pre-Invoice',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: NOT_SUBMITTED_STATUS_FILTER_ID,
    name: 'Not Submitted',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: SUBMITTED_STATUS_FILTER_ID,
    name: 'Submitted',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: IN_REVISION_STATUS_FILTER_ID,
    name: 'In Revision',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: NOT_PAID_STATUS_FILTER_ID,
    name: 'Not Paid',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: PARTIALLY_PAID_STATUS_FILTER_ID,
    name: 'Partially Paid',
    filterTypeId: STATUS_FILTER_TYPE
  },
  {
    id: FULLY_PAID_STATUS_FILTER_ID,
    name: 'Fully Paid',
    filterTypeId: STATUS_FILTER_TYPE
  }
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/invoiceFilterEnums.ts